export const DestinationTypeLabels = {
    NONE: "Choisir…",
    ROBOT: "Robot",
    ETIQUETAGE: "Étiquetage"
};

export const DestinationTypeValues = Object.fromEntries(
    Object.entries(DestinationTypeLabels).map(([key, label]) => [key, key])
);
